/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PendingApprovalsResponseDto } from '../../models/pending-approvals-response-dto';

export interface AdminInsightsControllerGetPendingApprovalsV1$Params {
}

export function adminInsightsControllerGetPendingApprovalsV1(http: HttpClient, rootUrl: string, params?: AdminInsightsControllerGetPendingApprovalsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PendingApprovalsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminInsightsControllerGetPendingApprovalsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PendingApprovalsResponseDto>;
    })
  );
}

adminInsightsControllerGetPendingApprovalsV1.PATH = '/v1/admin/insights/pending-approvals';
